import React, { useState } from 'react';
import { Card, Input, Button } from '../../components/ui';
import { AlertTriangle, TrendingUp, Users } from 'lucide-react';
import { cn } from '../../lib/utils';

export function SponsorshipRoiCalculatorTool() {
  const [cost, setCost] = useState('5000');
  const [impressions, setImpressions] = useState('50000');
  const [ctr, setCtr] = useState('2');
  const [conversionRate, setConversionRate] = useState('5');
  const [acv, setAcv] = useState('150');

  const cst = parseFloat(cost) || 0;
  const imp = parseInt(impressions) || 0;
  const clickRate = parseFloat(ctr) || 0;
  const cvRate = parseFloat(conversionRate) || 0;
  const val = parseFloat(acv) || 0;

  const clicks = Math.ceil(imp * (clickRate / 100));
  const leads = Math.ceil(clicks * (cvRate / 100));
  const revenue = leads * val;
  const roi = cst > 0 ? ((revenue - cst) / cst) * 100 : 0;

  return (
    <div className="grid lg:grid-cols-2 gap-8 text-left">
      <div className="space-y-6">
        <Card className="p-6 space-y-4">
          <h3 className="text-lg font-bold">Campaign Variables</h3>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400">Sponsorship Cost ($)</label>
              <Input type="number" value={cost} onChange={e => setCost(e.target.value)} />
            </div>
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400">Expected Impressions</label>
              <Input type="number" value={impressions} onChange={e => setImpressions(e.target.value)} />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400">CTR / Engagement (%)</label>
              <Input type="number" value={ctr} onChange={e => setCtr(e.target.value)} step="0.1" />
            </div>
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400">Conversion to Lead (%)</label>
              <Input type="number" value={conversionRate} onChange={e => setConversionRate(e.target.value)} step="0.1" />
            </div>
          </div>
          <div>
            <label className="text-[10px] uppercase font-bold text-gray-400">Avg Customer Value ($)</label>
            <Input type="number" value={acv} onChange={e => setAcv(e.target.value)} />
          </div>
        </Card>
      </div>

      <div className="space-y-4">
        <Card className="p-6 bg-violet-50 border-violet-100 flex items-center justify-between dark:bg-violet-900/20 dark:border-violet-800">
           <div>
             <span className="text-[10px] uppercase font-bold text-violet-600 block mb-1">Expected ROI</span>
             <p className={`text-4xl font-black ${roi >= 0 ? 'text-violet-700' : 'text-red-600'}`}>{roi.toFixed(1)}%</p>
           </div>
        </Card>
        <Card className="p-6 border-slate-200 dark:border-slate-800">
           <div className="space-y-3 font-mono text-sm">
             <div className="flex justify-between">
               <span className="text-gray-500">Expected Clicks / Engagements</span>
               <span className="font-bold">{clicks}</span>
             </div>
             <div className="flex justify-between">
               <span className="text-gray-500">Estimated New Leads / Customers</span>
               <span className="font-bold">{leads}</span>
             </div>
             <div className="flex justify-between border-t pt-2 mt-2">
               <span className="text-gray-700 dark:text-gray-300 font-bold">Projected Gross Revenue</span>
               <span className="font-bold text-green-600">${revenue.toLocaleString(undefined, {minimumFractionDigits: 2})}</span>
             </div>
           </div>
        </Card>
      </div>
    </div>
  );
}

